import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Chip,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import IngrdientIcon from "../../../assets/images/Icons/ingredient.svg";
import RecipeIcon from "../../../assets/images/Icons/recipeIcon.svg";
import IngregrientDisabled from "../../../assets/images/Icons/ingredientDisabled.svg";
import RecipeDisabledIcon from "../../../assets/images/Icons/ic_recipe_disabled.svg";
import { formatWeightWithUnits } from "../../../utils";
import { ArrowForwardIosSharp } from "@mui/icons-material";

export const SelectGroupContent = ({
  ingredientGroups = [],
  globalData,
  selectedGroups = [],
  setSelectedGroups,
  disabledGroupIds = [],
}) => {
  const [expandedGroups, setExpandedGroups] = useState([]);
  const getTypeIcon = (type, status) => {
    switch (type) {
      case "ingredient":
        return status ? IngrdientIcon : IngregrientDisabled;
      case "recipe":
        return status ? RecipeIcon : RecipeDisabledIcon;
      default:
        return null;
    }
  };

  const ingredientTag = (is_main_ingredient, is_batch_group, status) => {
    return (
      <>
        {is_main_ingredient || is_batch_group || !status ? (
          <Stack direction="row" gap="12px">
            <ul className="ingredient-list">
              {is_batch_group ? (
                <li>
                  <Typography
                    sx={{
                      color: status ? "#485364" : "#8E99AC",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "14.52px",
                    }}
                  >
                    Batch-Group
                  </Typography>
                </li>
              ) : null}
              {is_main_ingredient ? (
                <li>
                  <Typography
                    sx={{
                      color: status ? "#B42318" : "#8E99AC",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "14.52px",
                    }}
                  >
                    Main Ingredient
                  </Typography>
                </li>
              ) : null}{" "}
              {!status ? (
                <li>
                  <Typography
                    sx={{
                      color: "#0E7090",
                      fontSize: "12px",
                      fontWeight: 600,
                      lineHeight: "14.52px",
                    }}
                  >
                    Inactive
                  </Typography>
                </li>
              ) : null}
            </ul>
          </Stack>
        ) : null}
      </>
    );
  };

  const handleGroupToggle = (groupId, isDisabled) => {
    // Don't allow toggling if group is disabled
    if (isDisabled) return;

    if (selectedGroups.includes(groupId)) {
      setSelectedGroups(selectedGroups.filter((id) => id !== groupId));
    } else {
      setSelectedGroups([...selectedGroups, groupId]);
    }
  };

  const handleAccordionToggle = (groupId) => {
    if (expandedGroups.includes(groupId)) {
      setExpandedGroups(expandedGroups.filter((id) => id !== groupId));
    } else {
      setExpandedGroups([...expandedGroups, groupId]);
    }
  };

  return (
    <Stack sx={{ width: "100%", gap: "4px" }}>
      {ingredientGroups?.map((group) => {
        const isGroupSelected = selectedGroups.includes(group.group_id);
        const isAlreadyAdded = disabledGroupIds.includes(group.group_id);
        const isGroupDisabled =
          group.ingredients.every((item) => !item.status) || isAlreadyAdded;

        return (
          <Stack
            key={group.id}
            sx={{
              width: "100%",
            }}
          >
            <Accordion
              expanded={expandedGroups.includes(group.group_id)}
              onChange={() => handleAccordionToggle(group.group_id)}
              sx={{
                backgroundColor: "#F7FAFC",
                boxShadow: "none",
                "&:before": { display: "none" },
                borderRadius: "0 !important",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ArrowForwardIosSharp sx={{ fontSize: "0.9rem" }} />
                }
                sx={{
                  minHeight: "34px",
                  height: "34px",
                  p: "0 0 0 8px",
                  flexDirection: "row-reverse",
                  "&.Mui-expanded": {
                    minHeight: "34px",
                    height: "34px",
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "0",
                    alignItems: "center",
                    flex: 1,
                  },
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    marginRight: "8px",
                    marginLeft: 0,
                    transform: "rotate(0deg)",
                    "&.Mui-expanded": {
                      transform: "rotate(90deg)",
                    },
                  },
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ width: "100%", flex: 1 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Stack direction="row" alignItems="center" gap="8px">
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "12px",
                        lineHeight: "14.52px",
                        color: isAlreadyAdded ? "#8E99AC" : "#111C2B",
                      }}
                    >
                      {group?.name}
                    </Typography>
                    {isAlreadyAdded && (
                      <Chip
                        label="Added"
                        size="small"
                        sx={{
                          height: "18px",
                          fontSize: "10px",
                          fontWeight: 600,
                          backgroundColor: "#E6EEF7",
                          color: "#485364",
                        }}
                      />
                    )}
                  </Stack>
                  <Checkbox
                    checked={isGroupSelected || isAlreadyAdded}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleGroupToggle(group.group_id, isGroupDisabled);
                    }}
                    disabled={isAlreadyAdded}
                    size="small"
                    sx={{ mr: "-8px" }}
                  />
                </Stack>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0 }}>
                <Box
                  sx={{
                    border: "1px solid #DFE8F2",
                    borderRadius: "4px",
                    boxShadow: "#000000",
                  }}
                >
                  {group.ingredients?.map((ingredient) => {
                    return (
                      <Grid
                        key={ingredient.ingredient_id}
                        container
                        sx={{
                          backgroundColor: "#FFF",
                          p: "8px",
                          gap: "12px",
                          borderBottom: "1px solid",
                          borderColor: "divider",
                        }}
                      >
                        <Grid item m="auto" width="18px" height="18px">
                          <Box
                            width="18px"
                            height="18px"
                            component="img"
                            src={getTypeIcon(
                              ingredient.type,
                              ingredient.status,
                            )}
                            alt="ingredient type icon"
                          />
                        </Grid>
                        <Grid item flex={1}>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: "14px",
                              color: ingredient.status ? "#111C2B" : "#8E99AC",
                            }}
                          >
                            {ingredient.name}
                          </Typography>
                          {ingredientTag(
                            ingredient.is_main_ingredient,
                            ingredient.is_batch_group,
                            ingredient.status,
                          )}
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          display="flex"
                          alignItems="center"
                          justifyContent="flex-end"
                        >
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "400",
                              lineHeight: "16.94px",
                              color: ingredient.status ? "" : "#485364",
                            }}
                          >
                            {formatWeightWithUnits(
                              ingredient.base_unit_qty,
                              ingredient.base_unit_symbol,
                              globalData?.all_Units,
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  })}

                  <Stack
                    sx={{
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#E6EEF7",
                      height: "34px",
                      p: "10px 8px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "12px",
                        color: isGroupDisabled ? "#8E99AC" : "#111C2B",
                      }}
                    >
                      Group Total
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "12px",
                        lineHeight: "14.52px",
                        color: isGroupDisabled ? "#8E99AC" : "#111C2B",
                      }}
                    >
                      {formatWeightWithUnits(
                        group?.total_ingredient_qty,
                        group?.total_qty_unit,
                        globalData?.all_Units,
                      )}
                    </Typography>
                  </Stack>
                  {group.has_boiling_weight === 1 && (
                    <Stack
                      sx={{
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        backgroundColor: "#D4E4FD",
                        height: "34px",
                        p: "10px 8px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "12px",
                          lineHeight: "14.52px",
                          color: isGroupDisabled ? "#8E99AC" : "#111C2B",
                        }}
                      >
                        Group Boiled Weight
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "12px",
                          lineHeight: "14.52px",
                          color: isGroupDisabled ? "#8E99AC" : "#111C2B",
                        }}
                      >
                        {formatWeightWithUnits(
                          group?.total_qty,
                          group?.total_qty_unit,
                          globalData?.all_Units,
                        )}
                      </Typography>
                    </Stack>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Stack>
        );
      })}
    </Stack>
  );
};
